export default function(element) {
  element.disabled = false;
  element.classList.remove("disabled");
}
